export { default as faqBanner } from './faqBanner.svg';
export { default as faqMobileBanner } from './faqsMobileBanner.svg';
